import { products } from "../endpoints/products.endpoints";
import $axios from "../http/accessor";

const ProductsService = {
  getAllProducts: (
    page: number,
    count: number,
    search?: string,
    currencyId?: number | null,
  ) => {
    const params: any = {
      page,
      count,
    };
    if (search) {
      params.search = search;
    }
    if (currencyId) {
      params.currency_id = currencyId;
    }
    return $axios.get(products.all_products, { params });
  },

  getSingleProduct: (
    id: number,
    product_id: number,
    currencyId?: number | null,
  ) => {
    const url = products.single_product(id, product_id);
    const params: any = {};
    if (currencyId) {
      params.currency_id = currencyId;
    }
    return $axios.get(url, { params });
  },

  deleteProduct: (id: number, product_id: number) => {
    return $axios.delete(products.delete_product(id, product_id));
  },

  deleteProductImages: (id: number, product_id: number, formData: FormData) => {
    return $axios.put(products.delete_product_images(id, product_id), formData);
  },

  getCurrency: () => {
    return $axios.get(products.get_currency);
  },

  syncElasticsearch: () => {
    return $axios.post(products.sync_elasticsearch);
  },
};

export default ProductsService;
